import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';

import { AuthService } from 'src/services/auth.service';

@Component({
  selector: 'app-super-admin-help-center-demo',
  templateUrl: './super-admin-help-center-demo.component.html',
  styleUrls: ['./super-admin-help-center-demo.component.scss'],
})
export class SuperAdminHelpCenterDemoComponent implements AfterViewInit, OnDestroy {
  @ViewChild('frame') frame;

  constructor(public authService: AuthService) {}

  ngAfterViewInit() {
    this.authService.startHelpCenter();
  }

  ngOnDestroy() {
    this.authService.stopHelpCenter();
  }
}
